"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var BaseModel_1 = require("./BaseModel");
var SparkPostRequest;
(function (SparkPostRequest) {
    var Options = (function () {
        function Options() {
            this.start_time = undefined; // only email
            this.open_tracking = undefined; // template && email
            this.click_tracking = undefined; // template && email
            this.transactional = undefined; // template && email
            this.sandbox = undefined; // only email
            this.skip_suppression = undefined; // only email
            this.ip_pool = undefined; // only email
            this.inline_css = undefined; // only email
        }
        return Options;
    }());
    SparkPostRequest.Options = Options;
    var ContentHeaders = (function () {
        function ContentHeaders() {
            this.type = undefined;
            this.name = undefined;
            this.data = undefined;
        }
        return ContentHeaders;
    }());
    SparkPostRequest.ContentHeaders = ContentHeaders;
    var Content = (function () {
        function Content() {
            this.html = undefined; // html or text required
            this.text = undefined; // html or text required
            this.subject = undefined; // required for template
            this.from = undefined; // required for template
            this.reply_to = undefined;
            this.headers = undefined;
            /*
              The following attributes are used when specifying a stored template in the email content JSON object.
              Note that these attributes should not be present when using inline content.
            */
            this.template_id = undefined; // only for email
            this.use_draft_template = undefined; // only for email
        }
        return Content;
    }());
    SparkPostRequest.Content = Content;
    var Template = (function (_super) {
        __extends(Template, _super);
        function Template() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.id = undefined; // name or id are required
            _this.content = undefined;
            _this.published = undefined; // default false
            _this.name = undefined; // name or id are required
            _this.description = undefined;
            _this.options = undefined;
            return _this;
        }
        return Template;
    }(BaseModel_1["default"]));
    SparkPostRequest.Template = Template;
    var Recipient = (function () {
        function Recipient() {
            this.address = undefined;
        }
        return Recipient;
    }());
    SparkPostRequest.Recipient = Recipient;
    var Email = (function (_super) {
        __extends(Email, _super);
        function Email() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.id = undefined;
            _this.state = undefined;
            _this.options = undefined;
            _this.recipients = undefined;
            _this.campaign_id = undefined;
            _this.description = undefined;
            // public metadata;
            _this.substitution_data = undefined;
            _this.return_path = undefined;
            _this.content = undefined;
            _this.total_recipients = undefined;
            _this.num_generated = undefined;
            _this.num_failed_generation = undefined;
            _this.num_invalid_recipients = undefined;
            return _this;
        }
        return Email;
    }(BaseModel_1["default"]));
    SparkPostRequest.Email = Email;
})(SparkPostRequest = exports.SparkPostRequest || (exports.SparkPostRequest = {}));



//////////////////
// WEBPACK FOOTER
// ../model/dist/models/sparkpost.js
// module id = ../model/dist/models/sparkpost.js
// module chunks = main